import it from "./it";
import en from "./en";
import es from "./es";
import {I18n} from "@core/store/slices/i18nSlice";

const i18n: I18n = {
  en: en,
  it: it,
  es: es,
};

export default i18n;
